import { useMemo } from 'react';
import type { MapBounds } from '../types';
import { detectViewportCountry, type SupportedCountry } from '../utils/countryDetection';

/**
 * Reactive hook returning the current viewport's country.
 * Snapped to a 0.5° grid to avoid re-renders on every pixel of panning.
 */
export function useViewportCountry(bounds: MapBounds | null): SupportedCountry | null {
  const snappedKey = useMemo(() => {
    if (!bounds) return null;
    const snap = (v: number) => Math.round(v * 2) / 2; // 0.5° grid
    return `${snap(bounds.latMin)},${snap(bounds.lonMin)},${snap(bounds.latMax)},${snap(bounds.lonMax)}`;
  }, [bounds]);

  return useMemo(() => {
    if (!bounds) return null;
    return detectViewportCountry(bounds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snappedKey]);
}
